import { GetterTree } from "vuex";
import { RootState } from "../../types";
import {
  DeskState,
  WaitingPlayer,
  Decks,
  DeckInfo,
  ReleativOrderEntry,
  PlaceName,
  PovertyCards,
  GameModeInfos,
} from "./types";
import { userId } from "../user";

import {
  FriendRef,
  ItemRef,
  HandDocument,
  collectPlayedCards,
  checkWedding,
  playableCards,
  PossibleRestriction,
  TrickCard,
  Announcement,
  PlayerSides,
  AnnouncementValues,
  typeIsAnnouncementValues,
  Trick,
  checkPoverty,
  filterPovertyTrump,
  cardSorter,
  CARDS,
  isAnnouncementToLate,
  latestAnnouncement,
  calcNextAnnouncement,
  calcGameResult,
  PlayedGameDocument,
  GameResult,
} from "@dokogd/shared";

import { partition, last, keyBy, isBoolean, size } from "lodash";

const getDeskId = "getDeskId";
const getInvites = "getInvites";
const getPlayerWaitingList = "getPlayerWaitingList";
const hasAllPlayerJoined = "hasAllPlayerJoined";
const getGameCount = "getGameCount";
const isGameLeader = "isGameLeader";
const getRelativeOrder = "getRelativeOrder";
const getDecks = "getDecks";
const getActivePlayerId = "getActivePlayerId";
const getLeadId = "getLeadId";
const isMyTurn = "isMyTurn";
const amIPlayer = "amIPlayer";
const displayGameMode = "displayGameMode";
const getHaveISendMyHealthCheck = "getHaveISendMyHealthCheck";
const getOpenHealthChecks = "getOpenHealthChecks";
const getUnCheckedPlayer = "getUnCheckedPlayer";
const getLeadPlayer = "getLeadPlayer";
const getGameState = "getGameState";
const getMyCards = "getMyCards";
const getPossibleRestrictions = "getPossibleRestrictions";
const getPovertyCardCount = "getPovertyCardCount";
const getPovertyCards = "getPovertyCards";
const getPovertyInfo = "getPovertyInfo";
const getPlayedCards = "getPlayedCards";
const getCurrentTrick = "getCurrentTrick";
const getLastTrick = "getLastTrick";
const getAllowedCards = "getAllowedCards";
const isLastGameInRound = "isLastGameInRound";
const getGameResult = "getGameResult";
const getPlayedGame = "getPlayedGame";
const getLoadingState = "getLoadingState";
const getMappedUsers = "getMappedUsers";
const getSpectators = "getSpectators";
const getGameModeInfo = "getGameModeInfo";
const getRamCount = "getRamCount";
const getTableStats = "getTableStats";

const n = {
  getDeskId,
  getInvites,
  getPlayerWaitingList,
  hasAllPlayerJoined,
  getGameCount,
  isGameLeader,
  getDecks,
  getRelativeOrder,
  getActivePlayerId,
  getLeadId,
  isMyTurn,
  amIPlayer,

  displayGameMode,
  getHaveISendMyHealthCheck,
  getOpenHealthChecks,
  getUnCheckedPlayer,
  getLeadPlayer,

  getGameState,
  getMyCards,
  getPossibleRestrictions,
  getPovertyCards,
  getPovertyCardCount,
  getPovertyInfo,
  getPlayedCards,
  getCurrentTrick,
  getLastTrick,
  getAllowedCards,
  isLastGameInRound,
  getGameResult,
  getPlayedGame,
  getLoadingState,
  getMappedUsers,
  getSpectators,
  getGameModeInfo,
  getRamCount,
  getTableStats,
};

export const getters: GetterTree<DeskState, RootState> = {
  [n.getDeskId](state): null | string {
    return state.id;
  },
  [n.getInvites](state): ItemRef[] {
    return state.invites;
  },
  [n.getPlayerWaitingList](state): WaitingPlayer[] {
    if (state.desk !== null) {
      const d = state.desk;
      return d.participants.map(val => {
        const joined = d.joined[val.id] === true;
        return {
          ...val,
          joined,
        };
      });
    } else {
      return [];
    }
  },
  [n.hasAllPlayerJoined](state): boolean {
    const desk = state.desk;
    return (
      desk !== null && desk.participantIds.every(id => desk.joined[id] === true)
    );
  },
  [n.getGameCount](state): number {
    const desk = state.desk;
    return desk !== null ? desk.gameCount : 0;
  },
  [n.isGameLeader](state, _getter, _rootState, rootGetters): boolean {
    const uid = userId(rootGetters);
    const desk = state.desk;
    return desk !== null && desk.lead.id === uid;
  },
  [n.getRelativeOrder](
    state,
    _getters,
    _rootState,
    rootGetters
  ): ReleativOrderEntry[] {
    const uid = userId(rootGetters);
    const gameInfo = state.gameInfo;
    const participantIds = gameInfo?.playerIds ?? [];
    const participantOffset = uid
      ? participantIds.findIndex(v => v === uid)
      : -1;

    const offset = participantOffset >= 0 ? participantOffset : 0;
    const placeOrder: PlaceName[] = ["bottom", "left", "top", "right"];

    return [0, 1, 2, 3, 0, 1, 2, 3].splice(offset, 4).map((ro, idx) => {
      const res: ReleativOrderEntry = {
        participantIdx: ro,
        participantId: participantIds[ro],
        place: placeOrder[idx],
      };
      return res;
    });
  },
  [n.getDecks](state, getters): Decks {
    const relativeOrder = getters[n.getRelativeOrder] as ReleativOrderEntry[];
    const playedCards = getters[n.getPlayedCards] as string[];

    console.log(n.getDecks, relativeOrder, playedCards);

    const desk = state.desk;

    const friendForId = (id: string): FriendRef => {
      const Empty: FriendRef = {
        id: "",
        avatarId: "000",
        displayName: "Unknown",
      };
      if (desk) {
        return desk.participants.find(p => p.id === id) || Empty;
      } else {
        return Empty;
      }
    };

    const cardsForIdx = (idx: number): number | string[] => {
      if (state.gameInfo === null) {
        return 0;
      } else {
        const participantId = relativeOrder[idx].participantId;
        const hand = state.hands[relativeOrder[idx].participantIdx];

        if (typeof hand === "number") {
          return (
            hand -
            state.gameInfo.tricks.length -
            (state.gameInfo.currentTrick.findIndex(
              trickCard => trickCard.participantId === participantId
            ) === -1
              ? 0
              : 1)
          );
        } else {
          const sortStrategy = cardSorter(state.gameInfo?.mode || "default");
          return [...hand.cards]
            .filter(c => !playedCards.includes(c))
            .sort(sortStrategy);
        }
      }
    };

    const sideForIdx = (idx: number): null | PlayerSides => {
      const hand = state.hands[relativeOrder[idx].participantIdx];

      if (typeof hand === "number") {
        return null;
      } else {
        return hand.side;
      }
    };

    const createDeckInfo = (idx: number): DeckInfo => {
      const side = sideForIdx(idx);
      const participantId =
        state.gameInfo !== null ? relativeOrder[idx].participantId : "";
      let trickCount = 0;
      let announcement: Announcement | null = null;
      let nextAnnouncement: Announcement | null = null;
      if (state.gameInfo) {
        trickCount = state.gameInfo.tricks.reduce((p, c) => {
          return p + (c.owner === participantId ? 1 : 0);
        }, 0);
        announcement = state.gameInfo.announcements[participantId] ?? null;

        if (side) {
          const storedAnnouncement = Object.values(
            state.gameInfo.announcements
          ).reduce((p, c) => {
            if (c.side === side) {
              return latestAnnouncement(c.value, p);
            } else {
              return p;
            }
          }, null as AnnouncementValues | null);
          const possibleAnnouncement = calcNextAnnouncement(storedAnnouncement);

          if (
            state.gameInfo.sideDectectionRound !== null &&
            typeIsAnnouncementValues(possibleAnnouncement) &&
            !isAnnouncementToLate(
              state.gameInfo.sideDectectionRound,
              state.gameInfo.tricks.length,
              possibleAnnouncement
            )
          ) {
            nextAnnouncement = {
              side,
              value: possibleAnnouncement,
            };
          }
        }
      }
      return {
        cards: cardsForIdx(idx),
        announcement,
        nextAnnouncement,
        owner: friendForId(participantId),
        trickCount,
        side,
      };
    };
    console.log(n.getDecks, relativeOrder, state.gameInfo, state.hands);

    const decks: Decks = {
      bottom: createDeckInfo(0),
      left: createDeckInfo(1),
      top: createDeckInfo(2),
      right: createDeckInfo(3),
    };
    console.log(n.getDecks, decks);

    return decks;
  },

  [n.getActivePlayerId](state) {
    return state.gameInfo?.player ?? "";
  },
  [n.getLeadId](state) {
    return state.gameInfo?.lead ?? "";
  },
  [n.isMyTurn](_state, getters, _rootState, rootGetters) {
    const uid = userId(rootGetters);
    const activePlayerId = getters[n.getActivePlayerId] as string;

    return uid === activePlayerId;
  },
  [n.amIPlayer](state, _getters, _rootState, rootGetters) {
    const uid = userId(rootGetters);
    return !!uid && (state.gameInfo?.playerIds.includes(uid) ?? false);
  },
  [n.displayGameMode](state) {
    return state.displayGameMode;
  },
  [n.getHaveISendMyHealthCheck](state, _getters, _rootState, rootGetters) {
    const uid = userId(rootGetters);
    return uid && isBoolean(state.gameInfo?.restrictions[uid]);
  },
  [n.getOpenHealthChecks](state) {
    return 4 - size(state.gameInfo?.restrictions ?? {});
  },
  [n.getUnCheckedPlayer](state) {
    const restrictions = state.gameInfo?.restrictions ?? {};
    return (state.gameInfo?.playerIds ?? [])
      .filter(playerId => !restrictions[playerId])
      .map(playerId => state.desk?.participants.find(p => p.id === playerId));
  },
  [n.getLeadPlayer](state): ItemRef | null {
    const playerId = state.gameInfo?.lead;
    return state.desk?.participants.find(p => p.id === playerId) ?? null;
  },

  [n.getGameState](state) {
    return state.gameInfo?.gameState ?? null;
  },
  [n.getMyCards](state, _getters, _rootState, rootGetters) {
    const uid = userId(rootGetters);

    const handFinder = (
      hand: number | HandDocument<CARDS[]>
    ): hand is HandDocument => {
      return typeof hand !== "number" && hand.owner.id === uid;
    };
    const myHand = state.hands.find(handFinder);

    if (myHand) {
      return myHand.cards;
    } else {
      return [];
    }
  },
  [n.getPossibleRestrictions](_state, getters): PossibleRestriction[] {
    const myCards = getters[n.getMyCards] as CARDS[];

    if (myCards.length === 10) {
      const possibleRestriction: PossibleRestriction[] = [
        "solo",
        "solo-Q",
        "solo-J",
        "solo-♣",
        "solo-♠",
        "solo-♥",
        "solo-♦",
      ];

      if (checkWedding(myCards)) {
        possibleRestriction.push("wedding");
      }

      if (checkPoverty(myCards)) {
        possibleRestriction.push("poverty");
      }

      return possibleRestriction;
    } else {
      return [];
    }
  },
  [n.getPovertyCards](_state, getters): PovertyCards {
    const myCards = getters[n.getMyCards] as CARDS[];
    const [trump, nontrumps] = partition(myCards, filterPovertyTrump);
    const isFoxPoverty =
      trump.length === 4 && (trump.includes("♦A-1") || trump.includes("♦A-2"));

    return {
      isFoxPoverty,
      trump,
      nontrumps,
    };
  },
  [n.getPovertyCardCount](state): number {
    const restriction = state.gameInfo?.restriction?.type ?? null;
    if (restriction instanceof Object) {
      return restriction.cards.length;
    } else {
      return 0;
    }
  },
  [n.getPovertyInfo](state) {
    console.log("getPovertyInfo", state.gameInfo, state.hands);
    if (
      state.gameInfo &&
      (state.gameInfo.gameState === "povertyCheck" ||
        state.gameInfo.gameState === "returnPoverty") &&
      state.gameInfo.restriction
    ) {
      const restriction = state.gameInfo.restriction.type;
      if (restriction instanceof Object) {
        return {
          playerId: state.gameInfo.restriction.playerId,
          cards: restriction.cards,
          sendCards: state.gameInfo.gameState === "returnPoverty",
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  },
  [n.getPlayedCards](state): string[] {
    if (state.gameInfo) {
      return collectPlayedCards(state.gameInfo);
    } else {
      return [];
    }
  },
  [n.getCurrentTrick](state): TrickCard[] {
    if (state.gameInfo) {
      const cards = state.gameInfo.currentTrick;
      return cards;
    } else {
      return [];
    }
  },
  [n.getLastTrick](state): Trick {
    if (state.gameInfo) {
      const cards = last(state.gameInfo.tricks);
      return cards ?? { owner: "", cards: [] };
    } else {
      return { owner: "", cards: [] };
    }
  },
  [n.getAllowedCards](state, getters): string[] {
    const myCards = getters[n.getMyCards] as CARDS[];
    const playedCards = getters[n.getPlayedCards] as CARDS[];

    const gameInfo = state.gameInfo;
    if (gameInfo) {
      const leadCard =
        gameInfo.currentTrick.length > 0 ? gameInfo.currentTrick[0].card : null;
      return playableCards(
        leadCard,
        gameInfo.mode || "default",
        myCards,
        playedCards
      );
    } else {
      return [];
    }
  },
  [n.isLastGameInRound](state): boolean {
    const gameInfo = state.gameInfo;
    if (gameInfo) {
      const wasSolo = gameInfo.mode?.startsWith("solo") ?? false;
      const wasLeadLastParticipant =
        gameInfo.lead ===
        gameInfo.participantIds[gameInfo.participantIds.length - 1];

      return !wasSolo && wasLeadLastParticipant;
    } else {
      return false;
    }
  },
  [n.getGameResult](state): null | GameResult {
    const desk = state.desk;
    if (!desk) {
      return null;
    }
    const lastGame = desk.games[state.watchGame];
    if (lastGame) {
      console.log(n.getGameResult, lastGame);
      const gameResult = calcGameResult(lastGame, desk.participants);

      // look up avatars

      return gameResult;
    } else {
      return null;
    }
  },
  [n.getPlayedGame](state): null | PlayedGameDocument {
    const desk = state.desk;
    if (!desk) {
      return null;
    }
    return desk.games[state.watchGame] ?? null;
  },
  [n.getLoadingState](state) {
    return state.loading;
  },
  [n.getMappedUsers](state) {
    const desk = state.desk;
    if (desk) {
      return keyBy(desk.participants, "id");
    } else {
      return {};
    }
  },
  [n.getSpectators](state) {
    const playerIds =
      state.gameInfo?.playerIds ?? state.desk?.participantIds ?? [];

    return (state.desk?.participants ?? []).filter(
      v => !playerIds.includes(v.id)
    );
  },
  [n.getGameModeInfo](state): GameModeInfos {
    const gameInfo = state.gameInfo;
    if (gameInfo) {
      return {
        mode: gameInfo.mode,
        restriction: gameInfo.restriction,
      };
    } else {
      return null;
    }
  },
  [n.getRamCount](state): number {
    return state.gameInfo?.ramCount ?? 0;
  },
  [n.getTableStats](state) {
    const desk = state.desk;
    const gameInfo = state.gameInfo;
    if (desk && gameInfo) {
      let deskPoints = 0;

      const gamesPerRound = desk.participantIds.length;
      const roundRange: number[] = [];

      const playerPointTotal = keyBy(
        desk.participants.map(player => {
          return {
            id: player.id,
            point: 0,
          };
        }),
        "id"
      );

      const stats = desk.games.map((playedGame, idx) => {
        console.log(
          `R (${idx}): `,
          playedGame.mode.startsWith("solo"),
          roundRange.length,
          roundRange.join(", ")
        );

        const roundIdx = roundRange.findIndex(v => idx < v);
        if (roundIdx < 0) {
          roundRange.push(
            gamesPerRound + (roundRange[roundRange.length - 1] ?? 0)
          );
        }
        if (playedGame.mode.startsWith("solo")) {
          roundRange[roundRange.length - 1]++;
        }
        console.log(
          `R (${idx}): `,
          roundIdx,
          roundRange.length,
          roundRange.join(", ")
        );

        const gamePoints = Object.values(playedGame.result.points)
          .map(v => Math.abs(v ?? Number.MAX_SAFE_INTEGER))
          .reduce((p, c) => {
            if (c < p) {
              return c;
            } else {
              return p;
            }
          }, Number.MAX_SAFE_INTEGER);
        deskPoints += gamePoints;
        return {
          gameIdx: idx,
          lead: playedGame.lead,
          firstCardBy: playedGame.tricks[0].cards[0].participantId,
          gameNo: idx + 1,
          roundNo: roundRange.length,
          mode: playedGame.mode,
          isSolo:
            typeof playedGame.mode === "string" &&
            playedGame.mode.startsWith("solo"),
          gamePoints,
          ramFactor: Math.pow(2, playedGame.ramCount),
          playerPoints: desk.participants.map(player => {
            const playerId = player.id;
            const delta = playedGame.result.points[playerId];
            playerPointTotal[playerId].point += delta ?? 0;
            const total = playerPointTotal[playerId].point;
            return {
              delta,
              total,
            };
          }),
        };
      });
      const total = desk.participants.map(player => {
        return playerPointTotal[player.id].point;
      });
      console.log("END: ", roundRange.length, roundRange.join(", "));

      return {
        participants: desk.participants,
        stats,
        total,
        deskPoints,
      };
    } else {
      return null;
    }
  },
};

export const getterNames = n;
